import { ThemeUICSSObject, spacing } from '@apia/theme';

const history: ThemeUICSSObject = {
  '&.checkboxContainer': {
    display: 'flex',
    flexDirection: 'row',
    gap: spacing(4),
    padding: spacing(3),
    alignItems: 'center',
  },
};

export default history;
